import React from 'react';
import IndustryPageTemplate from '@/components/IndustryPageTemplate';
import { industryAds } from '@/config/ads';

const ConsumerElectronics: React.FC = () => {
  return (
    <IndustryPageTemplate
      slug="consumer-electronics"
      industry="Consumer Electronics"
      heroHeadline="Bring product features to life with interactive demos."
      heroSubheadline="Let shoppers explore specs, compare models, and experience your products before they buy."
      section2Title="Visual, feature-rich products benefit from dynamic creative."
      section2Content="Consumer electronics are complex products with features that matter. Interactive ads let shoppers explore specs, zoom into details, compare models, and understand what makes your product special—all within the ad unit."
      section3Title="Interactive demos significantly outperform static display."
      section3Content="When shoppers can interact with products—rotating 3D views, exploring features, comparing options—they engage more deeply and convert at higher rates. Interactive product demos turn browsers into buyers."
      section4Title="Ideal for mobile, audio, smart home, and wearable tech."
      section4Content="Whether you're launching a flagship phone or promoting smart home devices, Adventive helps you create the interactive product experiences that drive consideration and purchase."
      heroImage="https://d64gsuwffb70l.cloudfront.net/69408eb499b5789ef7367cf9_1765838686951_d1358591.png"
      heroAd={industryAds.consumerElectronics1}
      section2Ad={industryAds.consumerElectronics2}
      section3Ad={industryAds.consumerElectronics3}
      accentColor="bg-indigo-100 text-indigo-700"
      stats={[
        { value: '4.5x', label: 'Engagement rate' },
        { value: '+95%', label: 'Time on ad' },
        { value: '2.6x', label: 'Purchase intent' },
        { value: '50%', label: 'Lower CPA' },
      ]}
      benefits={[
        'Mobile and smartphone brands',
        'Audio and headphone companies',
        'Smart home device makers',
        'Wearable tech brands',
      ]}
    />
  );
};

export default ConsumerElectronics;
